import Parse from 'parse';

import { USER_CONTACT_EMAIL_FIELD } from '@interfaces/users';

export const getEmailFromParseUser = (parseUser: Parse.Object): string => (
    String(parseUser.get(USER_CONTACT_EMAIL_FIELD) || parseUser.get('email') || '')
);

export const mapAdminUserToParseFields = <T extends Record<string, unknown>>(
    data: T
): Record<string, unknown> => {
    const { email, ...rest } = data;
    const parseFields: Record<string, unknown> = { ...rest, };

    if (email !== undefined) {
        parseFields[USER_CONTACT_EMAIL_FIELD] = email;
    }

    return parseFields;
};
